export default {
    loading (state) {
        return state.loading
    },
    accounts (state) {
        return state.accounts
    }
}
